import { render, staticRenderFns } from "./_WaitingView.vue?vue&type=template&id=3d6030e2"
import script from "./_WaitingView.vue?vue&type=script&lang=js"
export * from "./_WaitingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports